<template>
  <div class="filter-box">
    <div class="filter-label">当前章节：</div>
    <div class="filter-content">
      <a-select style="width: 420px" class="chapter-select" dropdownClassName="chapterDrop" @change="handleChange" v-model="chapterId" v-if="chapterData && chapterData.length > 0">
        <a-select-option v-for="(item) in chapterData" :key="item.id" :value="item.id">
          {{ item.name }}
        </a-select-option>
      </a-select>
    </div>
    <div class="filter-tips">
      <!-- <a-popover v-if="theme && theme.length >= 155" placement="bottom">
        <template slot="content">
          <span>【本章实践主题】</span>{{ theme||'-' }}
        </template>
        <span>【本章实践主题】</span>{{ theme||'-' }}
      </a-popover>
      <span v-else>【本章实践主题】</span>{{ theme||'-' }} -->
      <a-popover placement="bottom">
        <template slot="content">
          <span>【本章实践主题】</span>{{ theme||'-' }}
        </template>
        <b>【本章实践主题】{{ theme||'-' }}</b>
      </a-popover>
    </div>

  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "ChapterFilter",
  props: {
    theme: {
      type: String,
      default: ""
    }
  },
  computed: {
    ...mapState({
      chapterData: (state) => state.train.chapterData,
    }),
    currentChapter () {
      return this.chapterData.find(item => item.id === this.chapterId) || {};
    }
  },
  data () {
    return {
      chapterId: null, // 改为绑定 chapter_id
    };
  },
  watch: {
    chapterData: {
      handler (newVal) {
        if (newVal && newVal.length > 0) {
          const queryId = this.$route.query.chapter_id;
          this.chapterId = queryId ? Number(queryId) : newVal[0].id; // 默认第一个章节
        }
      },
      immediate: true,
    },
    $route () {
      const queryId = this.$route.query.chapter_id;
      this.chapterId = queryId ? Number(queryId) : (this.chapterData[0] ? this.chapterData[0].id : null);
    }
  },
  mounted () {
    this.initChapter();
  },
  methods: {
    async initChapter () {
      const queryId = this.$route.query.chapter_id;
      this.chapterId = queryId ? Number(queryId) : (this.chapterData[0] ? this.chapterData[0].id : null);
    },
    handleChange (value) {
      this.chapterId = value;
      this.$router.replace({
        path: this.$route.path,
        query: { ...this.$route.query, chapter_id: value }
      }).catch(err => { err })
    },
  },
};
</script>


<style lang="less" scoped>
.filter-box {
    display: flex;
    background: linear-gradient(90deg, #ffefcc 0%, #ffebd3 100%);
    border-radius: 4px 4px 0px 0px;
    padding: 8px 25px;
    & > div {
        height: fit-content;
    }
    .filter-label {
        font-weight: bold;
        font-size: 14px;
        color: #373536;
        white-space: nowrap;
        margin-top: 5px;
    }
    .filter-tips {
        font-weight: 400;
        font-size: 14px;
        color: #6f4113;
        padding-left: 40px;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        margin-top: 5px;
    }
    .filter-content {
        .chapter-select {
            /deep/ .ant-select-arrow {
                width: 9px !important;
                height: 8px !important;
                margin-top: -4px;
                background-image: url('../../assets/image/student/stepFour/unitThree/down-default.png') !important;
                background-size: 9px 8px !important;
            }
            &.ant-select-open /deep/ .ant-select-arrow {
                background-image: url('../../assets/image/student/stepFour/unitThree/down.png') !important;
            }
            /deep/ .ant-select-selection-selected-value {
                font-weight: bold;
                font-size: 14px;
                color: #8b3c22;
            }
            /deep/ .ant-select-selection {
                height: 32px;
                border-radius: 0;
                line-height: 32px;
                border-color: #dbdad8 !important;
                border-right-width: 1px !important;
            }
            /deep/ .ant-select-selection--single {
                box-shadow: none !important;
            }
            /deep/ .ant-select-focused .ant-select-selection,
            /deep/ .ant-select-selection:focus,
            /deep/ .ant-select-selection:active,
            /deep/ .ant-select-selection:hover {
                border-color: #dbdad8 !important;
                border-right-width: 1px !important;
                box-shadow: none !important;
            }
        }
    }
}
</style>
